import React from "react";
import { AppointmentPhasePicker, LabelledRow } from "../../components";
import ArtistSelection from "../flightdetailsedit/artistselection";
import TravellersRow from "../flightdetailsedit/travellersrow";
import { Input, TextArea } from "semantic-ui-react";

interface Props {
  train: server.dto.ModifyTrainDetailsInstruction
  onTrainChanged: (train: server.dto.ModifyTrainDetailsInstruction) => void

  noArtistError: boolean
  travellersError: boolean

  initialArtist: server.dto.ArtistSmall
  initialTravellers: server.dto.ContactSmallV2[]
  initialPhase: server.dto.AppointmentPhases
}

const TrainJourneyEdit = (props: Props) => {
  const { travelAgency, notes } = props.train;
  const { noArtistError, travellersError } = props;
  const [artist, setArtist] = React.useState<server.dto.ArtistSmall>(props.initialArtist);
  const [travellers, setTravellers] = React.useState<server.dto.ContactSmallV2[]>(props.initialTravellers);
  const [phase, setPhase] = React.useState<server.dto.AppointmentPhases>(props.initialPhase);
  const onTrainChanged = (partialTrain: Partial<server.dto.ModifyTrainDetailsInstruction>) => {
    const newTrain: server.dto.ModifyTrainDetailsInstruction = {
      ...props.train,
      ...partialTrain
    };

    props.onTrainChanged(newTrain);
  };

  const onArtistChanged = (newArtist: server.dto.ArtistSmall) => {
    setArtist(newArtist);
    onTrainChanged({ artistId: newArtist?.artistId });
  };

  const onTravellersChanged = (newTravellers: server.dto.ContactSmallV2[]) => {
    setTravellers(newTravellers);
    onTrainChanged({ travellerIds: newTravellers.map(t => t.contactId) });
  };

  const onPhaseChanged = (newPhase: server.dto.AppointmentPhases) => {
    setPhase(newPhase);
    onTrainChanged({ phase: newPhase });
  };

  return <table className="s1_table bordergrid gray">
    <tbody>
      <tr>
        <td className="label">{RESX.Status.resxStatus}</td>
        <td className="padding" colSpan={2}>
          <AppointmentPhasePicker
            value={phase}
            onChange={onPhaseChanged}
          />
        </td>
      </tr>

      <LabelledRow label={site.currentEnvironment.functionGroups.artist.singular}>
        <ArtistSelection
          noArtistError={noArtistError}
          artist={artist}
          onArtistSelected={onArtistChanged}
        />
      </LabelledRow>

      <TravellersRow
        error={travellersError}
        artist={artist}
        travellers={travellers}
        onTravellersChanged={onTravellersChanged}
      />

      <LabelledRow label={RESX.Flight.TravelAgency}>
        <Input
          fluid
          type="text"
          maxLength={serverReference.constants.flight.maxTravelAgencyLength}
          onChange={(_, { value }) => { onTrainChanged({ travelAgency: value }); }}
          value={travelAgency} />
      </LabelledRow>
      <LabelledRow label={RESX.Note.Notes}>
        <TextArea
          maxLength={serverReference.constants.flight.maxNotesLength}
          rows={3}
          onChange={(e) => { onTrainChanged({ notes: (e.target as any).value }); }}
          value={notes} />
      </LabelledRow>
    </tbody>
  </table>;
};

export default TrainJourneyEdit;